import { tv } from "@fanka/tailwind-variants";
import clsx from "clsx";

export const SEGMENT_CONTROL_CLASS_NAME = tv({
  // 余白は仮
  base: clsx(
    "relative px-2 flex items-center justify-center flex-1 py-[3px] h-[26px] rounded-[3px] group",
    "disabled:text-base-disabled disabled:cursor-not-allowed",
  ),
  variants: {
    active: {
      true: "bg-brand-black disabled:bg-ui-100 disabled:hover:bg-ui-100",
      false: "hover:bg-grayScale-200 hover:cursor-pointer disabled:hover:bg-ui-0",
    },
  },
});

export const SEGMENT_CONTROL_CONTENT_CLASS_NAME = tv({
  base: "text-ui14 [&_svg]:w-5 [&_svg]:group-disabled:fill-base-disabled",
  variants: {
    active: {
      true: "text-ui-0 fill-ui-0 [&_svg]:fill-ui-0 [&_svg]:h-5",
      false: "",
    },
  },
});
